<template>
  <div class='tour'>
    <h1 class='daytour'>Magnificent Durmitor NP</h1>
    <div class='tourPic'>
      <img src='@/assets/multidaytours/tour3/01.jpg' />
    </div>
    <div>
      <ul class='fa-ul'>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDescription'
            ><h4 class='titles'>Tour description</h4></a
          >
          <div class='collapse' id='tourDescription'>
            <p class='pasus'>The program of this five-day tour is focused on the most impressive Montenegrin NP Durmitor and all its different characteristics and beauties. It is also the only national park in Montenegro that, together with the Tara river canyon, is included in the UNESCO list.</p>
            <p class='pasus'>The massif of Durmitor is known for its spectacular landforms and beautiful glacial lakes, old mountain villages and mountain lifestyle, spectacular viewpoints. In the surroundings of the massif, there are the mysterious medieval Stećci cemeteries, also included in the UNESCO list as a unique cultural heritage, they will tell us a story that is still a mystery, an equation with a lot of unknowns. Tara river canyon as part of NP is an attraction in itself and one of the deepest canyons in the world. The canyon is home to the clear Tara River known by the nickname "Tear of Europe".</p>
            <p class='pasus'>During this tour, we will have the opportunity to visit some Montenegrin landmarks such as Ostrog, the most visited and most interesting Orthodox monastery in Montenegro, Biogradska gora National Park, known for its primeval forest and beautiful glaciel lake in the heart of the park, canyons of Morača, Piva and Komarnica rivers.</p>
            <p class='pasus'>We will also enjoy some activities such as rafting on the rapids of the Tara River, walks around the Durmitor lakes and through the Biogradska Gora old forest.If you wish we will ride horses and climb the local cable car to the Durmitor peaks.</p>
            <p class='pasus'>The special moments of the tour are the spectacular viewpoints where we will enjoy different landscapes every day.</p>
            <p class='pasus'>The tour is not physically demanding, we will try to walk as much as you want, spend time in different places as much as you want without changing significantly the program we agreed on.</p>
            <p class='pasus'>We will get to know the life and customs in the mountainous part of Montenegro, you will stay in regions known for their dairy specialties, river fish, forest fruits, honey, plum homemade brandy.</p>
            <p class='pasus'>And the local population will always welcome us with kindness and pride.</p>
            <p class='pasus'>Cheers!</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDetails'
            ><h4 class='titles'>Tour details</h4></a
          >
          <div class='collapse' id='tourDetails'>
            <p class='pasus'>Type of tour: Private</p>
            <p class='pasus'>Availability: June - October</p>
            <p class='pasus'>Group size: 1-7</p>
            <p class='pasus'>Departure from: Podgorica, Tivat</p>
            <p class='pasus'>Difficulty level: easy</p>
            <p class='pasus'>Duration: 4 nights / 5 days</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#itinerary'
            ><h4 class='titles'>Itinerary</h4></a
          >
          <ul class='collapse itinerary_days' id='itinerary'>
            <li>
              <a data-toggle='collapse' href='#day1'>
                <h5 class='sub-titles'>
                  Day 1 -  Arival day,  Amazing Ostrog monastery, Komarnica canyon view, Black lake
                </h5></a
              >
              <div class='collapse' id='day1'>
                <p class='pasus'>On the first day of our five-day program, in a few hours we will slowly climb from the plains from an altitude of 50 m to the mountainous part of Montenegro to an altitude of about 1450 m above sea level. We will start the day from the largest Montenegrin urban center and finish the day and spend the night in Zabljak, a small town sitting at the highest elevation in the Balkans, in the immediate vicinity of the magnificent Durmitor mountain massif.</p>
                <p class='pasus'>On the way to Mount Durmitor and town of Žabljak, we will not miss the chance to visit the most famous Montenegrin monastery Ostrog located at a height of 900 m with a beautiful view of the Bjelopavlić plain, as well as the Komarnica nature park and the beginning of the Komarnica river canyon, known as one of the last discovered canyons in Europe</p>
                <p class='pasus'>Depending on the timing of your flight, in the afternoon or on the second day in the morning, we will visit the famous Black Lake, the largest of the 18 glacial lakes of the Durmitor massif.</p>
                <p class='pasus'>Accommodation- Hotel 4* Žabljak/ Private Apartment</p>
                <div class='tour-time'>
                  <p> <i class='fas fa-clock'></i> 3 hours</p>
                  <p> <i class='fas fa-route'></i> 135 km</p>
                </div>
                <img
                  class='daypic'
                  src='@/assets/multidaytours/tour3/day1.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day2'>
                <h5 class='sub-titles'>
                  Day 2 - Geological miracles of Durmitor NP, Piva lake & Tara canyon view
                </h5></a
              >
              <div class='collapse' id='day2'>
                <p class='pasus'>heritage site and its surroundings.</p>
                <p class='pasus'>We will start with the lookout offering a view on the deepest part of Tara canyon (1330m) Then we will go on a jeep or van tour along the famous route “ Durmitor ring “, 80 km long, which will allow us to get to know all the characteristics and beauties of the Durmitor massif. We will have the opportunity to observe the deep canyons of three rivers from magnificent view points, admire the geological features of Durmitor, get to know life in the summer herding settlements "katuns", and taste local specialties in a mountain restaurant.</p>
                <p class='pasus'>Accommodation- Hotel 4* Žabljak/ Private Apartment</p>
                <div class='tour-time'>
                  <p> <i class='fas fa-clock'></i> 3 hours</p>
                  <p> <i class='fas fa-route'></i> 85 km</p>
                </div>
                <img
                  class='daypic'
                  src='@/assets/multidaytours/tour3/day2.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day3'
                ><h5 class='sub-titles'>
                  Day 3 - Rafting, Stećci- mysterious medieval tombstones and glacier lakes ( mountain eyes)
                </h5></a
              >
              <div class='collapse' id='day3'>
                <p class='pasus'>Our third day will start with a short drive to the rafting camp, where we will be prepared for a small adventure, and then we will go to the starting point and enjoy a two-hour rafting on the rapids of the Tara River. After the rafting, lunch awaits us in the authentic ambience of the rafting camp and tasting of specialties made from local ingredients.</p>
                <p class='pasus'>After lunch We will pay a visit to a locality with medieval tombstones (Stećci), from recently protected by UNESCO, among locals called Greek graveyards, and hear the story of its origins and mysteries.</p>
                <p class='pasus'>On our way there will be some more beautiful glacier lakes and depending on the season different plants, flowers and birds those will tell us about local flora and fauna .</p>
                <p class='pasus'>If you wish, in the afternoon we can take the cable car to one of the Durmitor peaks or enjoy horse riding.</p>
                <p class='pasus'>Accommodation- Hotel 4* Žabljak/ Private Apartment</p>
                <div class='tour-time'>
                  <p> <i class='fas fa-clock'></i> 1 hour</p>
                  <p> <i class='fas fa-route'></i> 60 km</p>
                </div>
                <img
                  class='daypic'
                  src='@/assets/multidaytours/tour3/day3.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day4'
                ><h5 class='sub-titles'>
                  Day 4 - Magnificent Tara bridge and canyon, Biogradska Gora NP – Ancient forest and glacier lake, Monastery Morača
                </h5></a
              >
              <div class='collapse' id='day4'>
                <p class='pasus'>It's time to move on and enjoy the beauty of the Durmitor National Park, the Tara River canyon, and its pearls for a few more hours. We will admire the magnificent bridge on Tara and the environment that surrounds it, walk through the old black pine forest, feel the freshness of the mountain streams...</p>
                <p class='pasus'>Another national park is in our program on the fifth day. NP Biogradska Gora is famous for its pearl Biogradsko lake, but equally for one of the largest remaining European primeval forests. A very rich flora is one of the main features of this park. We will walk along the path around the lake, take a canoe ride if desired, hug 3 or 4 centuries old trees of impressive size.</p>
                <p class='pasus'>On our way to Podgorica, it would be a shame not to visit one of the oldest and most beautiful monasteries located on the banks of the Morača River, famous for its frescoes and icons.</p>
                <p class='pasus'>It's early evening and passing through the impressive canyon of the Morača river, we are slowly approaching Podgorica.</p>
                <p class='pasus'>Accommodation - 4 star hotel in Podgorica</p>
                <div class='tour-time'>
                  <p> <i class='fas fa-clock'></i> 3 hours</p>
                  <p> <i class='fas fa-route'></i> 170 km</p>
                </div>
                <img
                  class='daypic'
                  src='@/assets/multidaytours/tour3/day4.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day5'
                ><h5 class='sub-titles'>
                  Day 5 - Your last day in the morning you’ll have breakfast as usual. Then our driver will pick up your luggage and after breakfast we will drive you directly to the airport.
                </h5></a
              >
            </li>
            <li>
              <p class='pasus'>TOUR DATES: On request</p>
            </li>
          </ul>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#prices'>
            <h4 class='titles'>
              PRICE: based on the number of people in your group
            </h4></a
          >
          <div class='collapse' id='prices'>
            <ul class='square'>
              <li>1350 euro per person when two traveling</li>
              <li>900 euro per person when four traveling</li>
              <li>750 euro per person when six traveling</li>
              <li>Single room supplement: 120 EUR</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#included'>
            <h4 class='titles'>What is included in the price</h4></a
          >
          <div class='collapse' id='included'>
            <ul class='square'>
              <li class='pasus'>Accommodation for all nights</li>
              <li class='pasus'>Transportation (van or car)</li>
              <li class='pasus'>Breakfast and dinner for all days</li>
              <li class='pasus'>Bottle of water - 0.5l each day</li>
              <li class='pasus'>Transfer to the airport on the last day</li>
              <li class='pasus'>Entrance fees for all </li>
              <li class='pasus'>
                Rafting ticket & lunch
              </li>
              <li class='pasus'>Our assistance 24/7</li>
              <li class='pasus'>Licensed Tour Guide</li>
              <li class='pasus'>Travel map of Montenegro</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#notincluded'>
            <h4 class='titles'>Not included in price</h4></a
          >
          <div class='collapse' id='notincluded'>
            <ul class='square'>
              <li>Optional activities (horse riding, zip line, cable car)</li>
              <li>Lunch, drinks and tips</li>
              <li>Personal expenses</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'>
            <h4 class='titles'>Practical info</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>
                We recommend always carrying a light jacket, cap, sunglasses and shoes suitable for walking in the nature.
              </li>
              <li class='pasus'>
                The height difference we cross is about 1950 m. the highest point is at a height of about 2000 m above sea level.
              </li>
              <li class='pasus'>
                Prices in restaurants and bars are very affordable and we will always recommend places that we have already checked and are the best choice in a certain area.
              </li>
              <li class='pasus'>The currency is Euro.</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#optional'>
            <h4 class='titles'>Optional</h4></a
          >
          <div class='collapse' id='optional'>
            <ul class='square'>
              <li class='pasus'>Horse riding</li>
              <li class='pasus'>Zip line</li>
              <li class='pasus'>Cable car</li>
              <li class='pasus'>Additional walks during the tour</li>
              <li class='pasus'>
                Changes in the itinerary during the tour by agreement (do not affect the price)
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/multidaytours/tour3/h1.jpg'),
          thumbnail: require('@/assets/multidaytours/tour3/h1.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour3/h2.jpg'),
          thumbnail: require('@/assets/multidaytours/tour3/h2.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour3/h3.jpg'),
          thumbnail: require('@/assets/multidaytours/tour3/h3.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour3/h4.jpg'),
          thumbnail: require('@/assets/multidaytours/tour3/h4.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour3/h5.jpg'),
          thumbnail: require('@/assets/multidaytours/tour3/h5.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour3/h6.jpg'),
          thumbnail: require('@/assets/multidaytours/tour3/h6.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour3/h7.jpg'),
          thumbnail: require('@/assets/multidaytours/tour3/h7.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour3/h8.jpg'),
          thumbnail: require('@/assets/multidaytours/tour3/h8.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour3/h9.jpg'),
          thumbnail: require('@/assets/multidaytours/tour3/h9.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour3/h10.jpg'),
          thumbnail: require('@/assets/multidaytours/tour3/h10.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour3/h11.jpg'),
          thumbnail: require('@/assets/multidaytours/tour3/h11.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour3/h12.jpg'),
          thumbnail: require('@/assets/multidaytours/tour3/h12.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour3/h13.jpg'),
          thumbnail: require('@/assets/multidaytours/tour3/h13.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour3/h14.jpg'),
          thumbnail: require('@/assets/multidaytours/tour3/h14.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour3/h15.jpg'),
          thumbnail: require('@/assets/multidaytours/tour3/h15.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.daypic {
  width: 60vw;
  margin-bottom:20px;
}
.pasus {
  text-align: justify;
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/MT3_MagnificentDurmitor.vue